<template>
	<div class="h-100 nk-page d-flex flex-column">
		<nk-check-permission :policyClaims="policyClaims" />
		<nk-check-commercial-access :commercialAccess="commercialAccess" />
		<!-- <slot name="badges"></slot> -->
		<nk-form-info :data="additionalInfo" v-if="additionalInfo"></nk-form-info>
		<nk-display-mode-toggler :options="displayModeTogglerOptions" v-if="displayModeTogglerOptions" @toggleDisplayMode="toggleDisplayMode"></nk-display-mode-toggler>
		<nk-help :helpURL="helpURL"></nk-help>
		<nk-bootstrap-wrapper class="nk-page-body" :class="bodyClass" @resize="onResize">
			<slot :displayMode="displayMode" :isRightMode="displayMode === DISPLAYMODES.RIGHT"></slot>
		</nk-bootstrap-wrapper>
		<div v-if="localButtons.length > 0" class="nk-page-toolbar" tabscope>
			<ul>
				<li v-for="(b, i) in localButtons" :key="b.id" :class="{
					'group-begin': b.beginOfGroup && i >
						0,
					hidden: b.visible === false,
				}">
					<span v-if="b.beginOfGroup === true && i > 0" class="nk-page-toolbar-separator"></span>

					<nk-drop-button v-else-if="b.items" :tabindex="i + 1" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-drop-button>

					<nk-snapshot-button :options="b.options" v-if="b.type === 'snapshot'"></nk-snapshot-button>

					<nk-button v-else :tabindex="i + 1" class="btn btn-sm" :class="{
						'btn-primary': b.isPrimary,
						'btn-outline-primary': !b.isPrimary,
					}" :options="b" @click="buttonClicked" @optionsChanged="buttonOptionsChanged"></nk-button>

				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import FormInfo from '~/components/form/form-info'
	import DisplayModeToggler from '@/components/form/display-mode-toggler.vue'
	import NikanHelp from '~/components/general/nikan-help.vue'
	import SnapshotButton from '~/components/form/snapshot-button.vue'
	import emptyId from '~/statics/empty-id'

	const DISPLAYMODES = {
		UP: 'headerUp',
		RIGHT: 'headerRight',
	}

	export default {
		components: {
			'nk-form-info': FormInfo,
			'nk-help': NikanHelp,
			'nk-snapshot-button': SnapshotButton,
			'nk-display-mode-toggler': DisplayModeToggler
		},
		props: {
			bodyClass: {},
			buttons: { type: Array, default: () => [] },
			tokens: { type: [String, Array] },
			additionalInfoObj: {},
			displayModeTogglerOptions: { type: Object, default: null },
			policyClaims: { type: [Array, String, Object, Function], default: () => [] },
			commercialAccess: { type: [String, Function, Array], default: '' },
			helpURL: { type: String, default: '' }
		},
		emits: ['resize', 'buttonsChanged'],
		data() {
			return {
				DISPLAYMODES: DISPLAYMODES,
				displayMode: DISPLAYMODES.UP
			}
		},
		watch: {
			displayMode: {
				handler(val, oldVal) {
					if (oldVal === undefined) return
					let state = this.getActiveStateByKey(this.displayModeTogglerOptions.stateKey)
					if (state) {
						state.rowState = 'changed'
						state.value.val = val
					} else {
						state = {
							id: emptyId,
							key: this.displayModeTogglerOptions.stateKey,
							name: this.$t('document.display-mode.toggle-header-mode'),
							rowState: 'new',
							value: { val: val },
							isActive: true
						}
					}
					this.modifyStates([state])
					this.syncStates()
				}
			},
		},
		computed: {
			...mapGetters({
				getActiveStateByKey: 'appStates/getActiveByKey',
			}),
			localButtons() {
				if (!this.buttons || this.buttons.length === 0) {
					return []
				}

				return this.buttons.map((b) => {
					return _.merge(
						{
							mini: true,
							hideShortcut: true,
							hideTitle: true,
							hideIcon: false,
							hideTooltip: false,
							tooltipEnabled: false,
							beginOfGroup: false,
							visible: true,
							shortcut: {}
						},
						b
					)
				})
			},
			additionalInfo() {
				return this.additionalInfoObj
			}
		},
		mounted() {
			if (this.displayModeTogglerOptions)
				this.prepareDisplayMode()
		},
		methods: {
			...mapActions({
				modifyStates: 'appStates/modify',
				syncStates: 'appStates/sync',
			}),
			onResize(width, size) {
				this.$emit('resize', width, size)
			},
			buttonClicked(button, e) {
				e.preventDefault()
				var handle = button.handle
				if (handle != null) {
					handle(button, null, e)
				}
			},
			buttonOptionsChanged(button) {
				const index = this.buttons.findIndex((x) => x.id === button.id)
				if (index > -1) {
					_.extend(this.buttons[index], button)
					this.$emit('buttonsChanged', this.id, this.buttons)
				}
			},
			prepareDisplayMode() {
				let state = this.getActiveStateByKey(this.displayModeTogglerOptions.stateKey)
				this.displayMode = state?.value?.val || DISPLAYMODES.UP
			},
			toggleDisplayMode() {
				this.displayMode = this.displayMode === DISPLAYMODES.UP ? DISPLAYMODES.RIGHT : DISPLAYMODES.UP
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'page-button-click',
					el: this.$el,
					ctrlKey: undefined,
					altKey: undefined,
					shiftKey: undefined,
					context: this,
					handler: function (sender, e) {
						let button = _.head(
							this.buttons.filter((b) => {
								return (
									b.visible === true &&
									b.userHasAccess === true &&
									b.shortcut.keyCode === e.keyCode &&
									(b.shortcut.ctrlKey == null ||
										b.shortcut.ctrlKey === e.ctrlKey) &&
									(b.shortcut.shiftKey == null ||
										b.shortcut.shiftKey === e.shiftKey) &&
									(b.shortcut.altKey == null || b.shortcut.altKey === e.altKey)
								)
							})
						)

						if (button) {
							e.preventDefault()
							this.buttonClicked(button, e)
							return true
						}
					}
				})
			}
		}
	}
</script>
